import React, { useEffect, useState } from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Select from 'react-select'
import axios from 'axios';
import { useContext } from 'react';
import UserContext from '../../context/UserContext';


const SortableUser = ({ user }) => {


  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: user.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };




  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="p-2 mb-2 bg-white rounded shadow-sm border border-gray-200 cursor-move"
    >
      {user.name}
    </div>
  );
};

const SiteSettings = () => {

  
  const {apiURL} = useContext(UserContext)

    const [employees, setEmployees] = useState([]);
const [departs, setDeparts] = useState([])
    useEffect(() => {
      const getUsers = async () => {
        try {
          let g=[]
          const res = await axios.post(`${apiURL}/users/getemps`);
  let h = res.data.message.map(item => {
    let jj = { value: item.email, label: item.name}
  g.push(jj)
  })
       setEmployees(g);

        } catch (error) {
          console.error('Error fetching users:', error);
        }
      };
  
      getUsers();
    }, []);
   
console.log(employees)
console.log(departs)

    const changedepartments = selectedOptions => {
setDeparts(selectedOptions)
//setUpdateemployee({...updateemployee,departments:selectedOptions})

}


  
  const [selectedFileTypes, setSelectedFileTypes] = useState({
    pdf: true,
    jpg: false,
    png: false,
    ai: false,
      zip: false,
  });
  const [maxFileSize, setMaxFileSize] = useState(10);

  const handleFileTypeChange = (e) => {
    const { name, checked } = e.target;
    setSelectedFileTypes((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      approvedUsers: departs,
      selectedFileTypes,
      maxFileSize,
    });
    alert('Settings saved!');
  };

  return (
    <div className="w-full mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 text-left">Site Settings</h2>

      <form onSubmit={handleSubmit} className="space-y-6 text-left">
        {/* Drag and Drop User Permission Section */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Who can accept requests?
          </label>
              {/* Available Users */}
             
             <Select
             className='w-full'
             onChange={changedepartments}
                        options={employees}
                       value={departs}
                        isMulti
                        />
        </div>

        {/* File Types Section */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Accepted File Types
          </label>
          <div className="grid grid-cols-2 gap-2">
            {Object.keys(selectedFileTypes).map((type) => (
              <label key={type} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name={type}
                  checked={selectedFileTypes[type]}
                  onChange={handleFileTypeChange}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-600">.{type}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Max File Size Section */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Maximum File Size (MB)
          </label>
          <input
            type="number"
            value={maxFileSize}
            onChange={(e) => setMaxFileSize(e.target.value)}
            min="1"
            max="100"
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Submit Button */}
        <div className="flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Save Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default SiteSettings;